import {useBehavioralContext} from "../../../contexts";
import {useEffect} from "preact/compat";

const unsecuredCopyToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    document.body.prepend(textArea);
    textArea.focus();
    textArea.select();

    try {
        document.execCommand('copy');
    } catch (err) {
        console.error('Unable to copy to clipboard', err);
    }

    document.body.removeChild(textArea);
};

// Handles the behavior of the toast alert
const handleToastAlert = () => {
    const element = document.createElement("div");
    element.classList.add("font-museo");
    element.classList.add("coupon-toast-alert");
    element.textContent = "Cupom copiado";

    document.body.appendChild(element);

    // First timer to hide the element
    const timer = setTimeout(() => {
        element.classList.add("destroy-coupon-toast-alert");

        clearTimeout(timer);
    }, 2000);

    // Second timer to destroy the element
    const opacityTimer = setTimeout(() => {
        document.body.removeChild(element);

        clearTimeout(opacityTimer);
    }, 2300);
}

const cssClasses = (data) => {
    // Get the root element
    let root = document.querySelector(':root');

    root.style.setProperty('--cpa-bg', data.colors.bottom);
    root.style.setProperty('--cpa-txt', data.colors.bottomText);
}

export const useContent = (props) => {
    // Destructured props
    const {
        setIsOpen,
        data
    } = props;

    // Retrieves the method to access the sidebar cart component's properties
    const {handleCart} = useBehavioralContext();

    // Formats the product href without the .html suffix
    const formattedHref = data.product.href ? data.product.href.split(".html")[0] : "";

    // Copies the QR Code text to the clipboard
    const copyCodeToClipboard = () => {
        // Copy the text inside the text field
        if (window.isSecureContext && navigator.clipboard) {
            navigator.clipboard.writeText(data.coupon).then();
        } else {
            unsecuredCopyToClipboard(data.coupon);
        }

        // Displays the coupon toast message
        handleToastAlert();

        // Timeout to close the modal and open the sidebar cart
        const timer = setTimeout(() => {
            handleCart("_", "_", {
                isOpen: true,
                newProductData: {},
                url: `${formattedHref}`
            });

            setIsOpen(false);

            clearTimeout(timer);
        }, 2000);
    }

    useEffect(() => {
        cssClasses(data);
    }, [data]);

    return {
        copyCodeToClipboard
    }
}
